import styled from '@emotion/styled';
import { CSSObject } from '@emotion/serialize';
import { Component as ComponentContainer } from '@styles/layout';
import { SearchResultsPadding, FILTERS_WIDTH } from '@styles/search-layout';
import { mq } from '@styles/breakpoints';
import { ThemeProps } from '@theme/base';
import { TextComponent } from '@model/content';
import { TextMarkdown } from '@components/common/description';
import { useI18NextContext } from '@components/hooks';
import { americanize } from '@util/string';
import { ConditionalWrapper } from '@util/common';

const ContentContainer: any = styled(SearchResultsPadding)(({ theme }: ThemeProps) => ({
  [mq.large]: {
    paddingRight: FILTERS_WIDTH + theme.custom.spacing.large
  }
}));

export const TextContainer = ({ value, alignment, destination, data }: TextComponent) => {
  const t = useI18NextContext();

  const textAlign = alignment && americanize(alignment);
  const text = /\{\{/.test(value) ? t(value, { destination: destination?.display }) : value;
  const fullWidth = data?.fullWidth;

  return (
    <ComponentContainer isEdgeToEdge={fullWidth}>
      <ConditionalWrapper condition={fullWidth} wrapper={(children) => <ContentContainer>{children}</ContentContainer>}>
        <TextMarkdown description={text} styles={textAlign ? ({ textAlign } as CSSObject) : undefined} />
      </ConditionalWrapper>
    </ComponentContainer>
  );
};
